export default "__VITE_ASSET__Dhub1ul2__"